import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import config from 'constants/config'
import { staticPageMessages } from 'constants/config/i18nMessages'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  modalType?: string
}

function AccountAccessLegalText({ modalType }: Props) {
  const intl = useIntl()
  const isPhonePromptModal = modalType === 'promptAddPhone'
  const termsURL = config.contentLinks.termsAndConditions.href || config.contentLinks.termsAndConditions.to!
  const privacyURL = config.contentLinks.privacyPolicy.href || config.contentLinks.privacyPolicy.to!
  const loyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const privacyPolicyText = intl.formatMessage(staticPageMessages.privacyPolicy)

  return (
    <Caption colour="light-foreground-alt" variant="medium">
      {isPhonePromptModal && (
        <FormattedMessage
          id="f7gNggeLDLd_akEFMuK5"
          defaultMessage="By adding your mobile number, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          description="Legal text for phone number addition with T&Cs and privacy policy links"
          values={{
            privacyPolicy: privacyPolicyText,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isPhonePromptModal && loyaltyEnabled && (
        <FormattedMessage
          id="sK1qEmWqIu7rciOqhrmT"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> join the {loyaltyProgram} program, and to subscribe to marketing communications for offers, alerts and services."
          description="Account sign-up legal text linking to terms and privacy policy, with loyalty program enrolment and marketing consent"
          values={{
            privacyPolicy: privacyPolicyText,
            loyaltyProgram: getLoyaltyProgramDisplayName(),
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isPhonePromptModal && !loyaltyEnabled && (
        <FormattedMessage
          id="znipBfcVHP8gqcqagn18"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          description="Legal text for sign-up with T&Cs and privacy policy links"
          values={{
            privacyPolicy: privacyPolicyText,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
    </Caption>
  )
}

export default AccountAccessLegalText
